
import React, { useState } from "react";
import SimpleBar from 'simplebar-react';
import { useLocation } from "react-router-dom";
import { CSSTransition } from 'react-transition-group';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBook, faFileAlt, faSignOutAlt, faTable, faTimes, faHome, faStepBackward } from "@fortawesome/free-solid-svg-icons";
import { Nav, Button, Dropdown, Navbar, Image } from '@themesberg/react-bootstrap';
import { Link } from 'react-router-dom';

import { Routes } from "../routes";
import ReactHero from "../assets/img/technologies/react-hero-logo.svg";
import ProfilePicture from "../assets/img/team/profile-picture-3.jpg";
import SidebarItem from "./sidebar/SidebarItem";
import CollapsableSidebarItem from "./sidebar/CollapsableSidebarItem";

import { countEnabledPermissions } from '../helper/permission'

export default (props = {}) => {
  const location = useLocation();
  const [show, setShow] = useState(false);
  const showClass = show ? "show" : "";

  const onCollapse = () => setShow(!show);

  const permission = localStorage.getItem('permission') || ""
  const permissionPoint = countEnabledPermissions(permission)

  return (
    <>
      <Navbar expand={false} collapseOnSelect variant="dark" className="navbar-theme-primary px-4 d-md-none">
        <Navbar.Brand className="me-lg-5" as={Link} to={Routes.Overview.path}>
          <Image src={ReactHero} className="navbar-brand-light" />
        </Navbar.Brand>
        <Navbar.Toggle as={Button} aria-controls="main-navbar" onClick={onCollapse}>
          <span className="navbar-toggler-icon" />
        </Navbar.Toggle>
      </Navbar>
      <CSSTransition timeout={300} in={show} classNames="sidebar-transition">
        <SimpleBar className={`collapse ${showClass} sidebar d-md-block bg-primary text-white`}>
          <div className="sidebar-inner px-4 pt-3">
            <div className="user-card d-flex d-md-none align-items-center justify-content-between justify-content-md-center pb-4">
              <div className="d-flex align-items-center">
                <div className="user-avatar lg-avatar me-4">
                  <Image src={ProfilePicture} className="card-img-top rounded-circle border-white" />
                </div>
                <div className="d-block">
                  <h6>Hi, Jane</h6>
                  <Button as={Link} variant="secondary" size="xs" to={Routes.Signin.path} className="text-dark">
                    <FontAwesomeIcon icon={faSignOutAlt} className="me-2" /> Sign Out
                  </Button>
                </div>
              </div>
              <Nav.Link className="collapse-close d-md-none" onClick={onCollapse}>
                <FontAwesomeIcon icon={faTimes} />
              </Nav.Link>
            </div>
            <Nav className="flex-column pt-3 pt-md-0">
              {(permissionPoint > 1) &&
                <SidebarItem title="Quay về" link={Routes.Overview.path} icon={faStepBackward} setShow={setShow} />
              }

              <SidebarItem title="Trang chủ" link={Routes.Overview.path} icon={faHome} setShow={setShow} />

              <CollapsableSidebarItem eventKey="/customer/charge/" title="Nạp tiền" icon={faTable}>
                <SidebarItem title="Nạp tiền" link={Routes.CustomerAddChargeWeb.path} setShow={setShow} />
                <SidebarItem title="Lịch sử nạp tiền" link={Routes.CustomerChargeHistoryWeb.path} setShow={setShow} />
                <SidebarItem title="Lịch sử hoàn tiền" link={Routes.CustomerCashbackHistoryWeb.path} setShow={setShow} />
                <SidebarItem title="Lỗi nạp tiền" link={Routes.CustomerIssueCharge.path} setShow={setShow} />
                {/* <SidebarItem title="Thống kê" link={Routes.CustomerChargeSummary.path} setShow={setShow} /> */}
              </CollapsableSidebarItem>

              <Dropdown.Divider className="my-3 border-indigo" />

              <CollapsableSidebarItem eventKey="/customer/withdraw/" title="Rút tiền" icon={faTable}>
                <SidebarItem title="Rút tiền" link={Routes.CustomerWithdrawRequestApp.path} setShow={setShow} />
                <SidebarItem title="Rút tiền đã HT" link={Routes.CustomerWithdrawRequestWebConfirmed.path} setShow={setShow} />
                <SidebarItem title="Lịch sử rút tiền" link={Routes.CustomerWithdrawSummaryApp.path} setShow={setShow} />
              </CollapsableSidebarItem>
              <Dropdown.Divider className="my-3 border-indigo" />

              <CollapsableSidebarItem eventKey="/customer/refund/" title="Thu hồi" icon={faTable}>
                <SidebarItem title="Thu hồi App" link={Routes.CustomerRefundApp.path} setShow={setShow} />
                <SidebarItem title="Thu hồi Web" link={Routes.CustomerRefundWeb.path} setShow={setShow} />
                <SidebarItem title="Lịch sử thu hồi App" link={Routes.CustomerRefundHistoryApp.path} setShow={setShow} />
                <SidebarItem title="Lịch sử thu hồi Web" link={Routes.CustomerRefundHistoryWeb.path} setShow={setShow} />
              </CollapsableSidebarItem>
              <Dropdown.Divider className="my-3 border-indigo" />

              <SidebarItem title="Khách hàng" link={Routes.CustomerUser.path} setShow={setShow} />

              <SidebarItem title="Lịch sử giao dịch" link={Routes.CustomerTransactionHistory.path} setShow={setShow} />

              <SidebarItem title="Dòng tiền khách hàng" link={Routes.CustomerCashFlow.path} setShow={setShow} />

              <Dropdown.Divider className="my-3 border-indigo" />
            </Nav>
          </div>
        </SimpleBar>
      </CSSTransition>
    </>
  );
};
